module.exports = __webpack_public_path__ + "static/media/book_demo.fce8d1ea.png";